import { SupportTicketMessageAuthorMapper } from './SupportTicketMessageAuthor/SupportTicketMessageAuthorMapper.js';
import { SupportTicketAttachmentDetailsMapper } from '../SupportTicket/SupportTicketAttachmentDetails/SupportTicketAttachmentDetailsMapper.js';

class SupportTicketMessageMapper {
  static createModelFromResponse(response) {
    return {
      createdAt: response.created_at,
      htmlBody: response.html_body,
      author: SupportTicketMessageAuthorMapper.createModelFromResponse(response.author),
      attachments: response.attachments.map(attachment => SupportTicketAttachmentDetailsMapper.createModelFromResponse(attachment))
    };
  }
  static createApiPayload(_ref) {
    let {
      htmlBody,
      attachments
    } = _ref;
    return {
      html_body: htmlBody,
      attachments
    };
  }
}

export { SupportTicketMessageMapper };
//# sourceMappingURL=SupportTicketMessageMapper.js.map
